import { createContext, useContext, useMemo } from "react";
import { jsx } from "react/jsx-runtime";
//#region src/components/Icon/IconProvider.tsx
var IconSetContext = createContext({});
/**
* Replaces icon glyphs by name for everything inside it, so a brand pack can use its
* own icons (`pack.icons`) with no component changes. Names it doesn't set fall back
* to an outer provider, then to the default (Lucide) set. ThemeRoot sets one up from
* the brand pack.
*/
function IconProvider({ icons, children }) {
	const outer = useContext(IconSetContext);
	const merged = useMemo(() => icons ? {
		...outer,
		...icons
	} : outer, [outer, icons]);
	return /* @__PURE__ */ jsx(IconSetContext.Provider, {
		value: merged,
		children
	});
}
/** The replacement glyphs in scope ({} outside any IconProvider). */
function useIconSet() {
	return useContext(IconSetContext);
}
//#endregion
export { IconProvider, useIconSet };

//# sourceMappingURL=IconProvider.js.map